import React from 'react'
import * as Sentry from '@sentry/browser'

export default class ErrorWrapper extends React.Component {

  state = {
    error: null,
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })
      Sentry.captureException(error)
    })
  }

  reset = () => {
    this.props.reset()
    this.setState({ error: null })
  }

  render() {
    const { error } = this.state
    if (error) {
      return (
        <div style={{ color: 'red' }}>
          <h1>Все сломалось :(</h1>
          <button onClick={this.reset}>Обновить страницу</button> или
          <button onClick={() => Sentry.showReportDialog({
            lang: 'ru',
          })}>написать об ошибке</button>.
          <div>{error.message}</div>
          <pre>{error.stack}</pre>
        </div>

      )
    }
    return this.props.children
  }

}
